<template>
	<div class="ms-form-page container">
		<div v-if="form" class="ms-form-shell">
			<div class="text-center">
				<h1>{{ form.title }}</h1>
				<p class="ms-form-description">{{ form.description }}</p>
			</div>
			<div v-if="form.src" class="ms-form-frame" role="region" :aria-label="form.title">
				<iframe
					:title="form.title"
					:src="form.src"
					loading="lazy"
					allowfullscreen
				></iframe>
			</div>
			<p v-else class="ms-form-message" role="alert">
				This registration form is not configured yet. Please return to the registration page or contact us.
			</p>
			<div class="text-center ms-form-actions">
				<router-link :to="{ name: 'register' }" class="btn btn-yellow">Back to Registration</router-link>
			</div>
		</div>
		<div v-else class="ms-form-shell text-center">
			<h1>Registration Form Not Found</h1>
			<p class="ms-form-message" role="alert">The requested registration form is not available.</p>
			<router-link :to="{ name: 'register' }" class="btn btn-yellow">Back to Registration</router-link>
		</div>
	</div>
</template>

<script>
import microsoftForms from '@/config/microsoftForms'

export default {
	name: 'MicrosoftFormEmbed',
	props: {
		formKey: {
			type: String,
			required: true
		}
	},
	computed: {
		form() {
			return microsoftForms[this.formKey]
		}
	}
}
</script>
